import React, { useEffect } from 'react'
import Skills from '../Skills/Skills'
import HeaderPage from '../HeadPage/HeadPage'
import Education from '../Education/Education'

const Home = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    scrollToTop()
  }, [])
  return (
    <div>
      <HeaderPage />
      <Skills />
      <Education />
      {/* <WhatIdo/> */}
    </div>
  )
}

export default Home